import React, { useMemo } from 'react';
import { Loader } from '@aws-amplify/ui-react';
import { ThemeProvider } from '@aws-amplify/ui-react';

import useHealthCheck from 'hooks/useHealthCheck';
import { useLabelOptions } from './contexts/labelOptionsContext';
import { useLocaleState } from './contexts/localeContext';
import { getTheme } from './theme';

import Maintenance from './components/Maintenance';
import AuthPage from './components/AuthPage';
import Toasts from 'components/Toast';

import '@aws-amplify/ui-react/styles.css';
import 'App.css';

export default function App() {
  const { rtl } = useLocaleState();
  const { labelOptions } = useLabelOptions();
  const theme = useMemo(() => getTheme(labelOptions.brand), [labelOptions]);

  const { isMaintenance, healthCheckFirstInvoke } = useHealthCheck();

  return (
    <ThemeProvider theme={theme} direction={rtl ? 'rtl' : 'ltr'}>
      {healthCheckFirstInvoke && <Loader variation="linear" filledColor={theme.tokens.colors.brand.primary[80]} />}
      {isMaintenance && <Maintenance />}

      {!isMaintenance && !healthCheckFirstInvoke && <AuthPage />}
      <Toasts />
    </ThemeProvider>
  );
}
